import { Component, Input, OnInit, OnDestroy, EventEmitter, Output } from '@angular/core';
import { LogEntryPhoto } from '../../../models/logs/photos/LogEntryPhoto.interface';
import { EmailService } from '../../../service/email.service';
import { Subscription } from 'rxjs';
import { EmailPreviewResponse } from '../../../models/email/EmailPreviewResponse';
import { PhotoService } from '../../../service/photo.service';
import { ReceivingLogStateService } from '../../../domain/receiving-log/receiving-log-state.service';
import { ApiReceivingLogRow } from '../../../models/logs/ApiReceivingLogRow';
import { AssetsDataService } from '../../../service/assets-data.service';

@Component({
  selector: 'app-preview-email',
  templateUrl: './preview-email.component.html',
  styleUrls: ['./preview-email.component.css']
})
export class PreviewEmailComponent implements OnInit, OnDestroy {

  @Input() includePhotosInEmail: boolean = true;
  /**
   * True when the log being previewed had outstanding/damaged items and so was
   * accompanied by a separate expediting (missing-items) email. Surfaces a note
   * on the resend preview so the sender knows expediting was involved.
   */
  @Input() hasExpeditingEmail: boolean = false;
  @Output() togglePhotosInEmail = new EventEmitter<boolean>();

  private photosSubscription?: Subscription;
  private emailContentSubscription?: Subscription;
  private isLoadingSubscription?: Subscription;
  private logDataSubscription?: Subscription;

  private _emailService: EmailService;
  private _photoService: PhotoService;
  private _receivingLogService:ReceivingLogStateService;
  private _assetsDataService: AssetsDataService;

  public logRowData: ApiReceivingLogRow | null = null;
  public emailContent: EmailPreviewResponse = new EmailPreviewResponse();
  public photos: LogEntryPhoto[] = [];
  public isLoading: boolean = false;
  public loadingMessage: string = '';
 
  constructor(photoService: PhotoService, emailService: EmailService, 
   receivingLogService:ReceivingLogStateService, assetsDataService: AssetsDataService) { 
    this._photoService = photoService;
    this._emailService = emailService;
    this._receivingLogService =receivingLogService;
    this._assetsDataService = assetsDataService;

  }

  ngOnInit(): void {
    this.photosSubscription = this._photoService.logEntryphotos$.subscribe(photos => {
      this.photos = photos;
    });
    this.emailContentSubscription = this._emailService.emailMessageData.subscribe(content => {
      this.emailContent = content;
    });
    this.isLoadingSubscription = this._emailService.dataLoading.subscribe(loading => {
      this.isLoading = loading.isLoading;
      this.loadingMessage = loading.message || '';
    });
    this.logDataSubscription = this._receivingLogService.logData$.subscribe(logData => {
      this.logRowData = logData;
    });
  }

  ngOnDestroy(): void {
    if (this.photosSubscription) {
      this.photosSubscription.unsubscribe();
    }
    if (this.emailContentSubscription) {
      this.emailContentSubscription.unsubscribe();
    }
    if (this.isLoadingSubscription) {
      this.isLoadingSubscription.unsubscribe();
    }
    if (this.logDataSubscription) {
      this.logDataSubscription.unsubscribe();
    }
  }

  public handleTogglePhotosInEmail(event: any): void {
    console.log('handleTogglePhotosInEmail within preview email component', event.detail.checked);
    this.includePhotosInEmail = event.detail.checked;
    this.togglePhotosInEmail.emit(event);
  }
}
